// extracted by mini-css-extract-plugin
module.exports = {"section":"NotFound_section__37LVx"};